import { Injectable } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import { MessageService } from '../__common/message.service';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError = <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {

  constructor(private messageService: MessageService) { }

  createNewHandleError = (serviceName = '') => <T>

  (operation = 'operation', result = {} as T) => this.handleError(serviceName, operation, result);

  /** Create curried handleError function that already knows the service name */

  createHandleError = (serviceName = '') => <T>

  (operation = 'operation', result = {} as T) => this.handleErrorOld(serviceName, operation, result);


  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   * */

  handleErrorOld<T>(serviceName = '', operation = 'operation', result = {} as T) {

    return (error: HttpErrorResponse): Observable<T> => {
      // TODO: send the error to remote logging infrastructure

      //console.error('ERROR TO DO!!->');
      console.error(error); // log to console instead

      const message = (error.error instanceof ErrorEvent) ?

        error.error.message :

        `server returned code ${error.status} with body "${error.error}"`;

      // TODO: better job of transforming error for user consumption
      
      this.messageService.add(`${serviceName}: ${operation} failed: ${message}`);

      // Let the app keep running by returning a safe result.
      return of( result );

    };

  }

  handleErrorTry<T>(serviceName = '',operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {
      console.error(`${operation} failed:`, error);
  
      // Optionally log error to a service or display to user
      /* const message = (error instanceof ErrorEvent)
        ? error.error.message
        : `Server returned code ${error.status}, body was: ${JSON.stringify(error.error)}`; */
      let message;
      debugger
      if(error){
        message = error.message + ' Error Name:' +error.name + 'Status Text: '+error.statusText;
        /* let ok = error.ok;
        let statusText = error.statusText;
        let url = error.url; */
      }

      //this.messageService.add(`${serviceName}: ${operation} failed: ${message}`);
  
      // Properly propagate the error
      return throwError(() => ({
        message: message,
        status: error.status,
        error: error
      }));
    };
  }

  handleError<T>(serviceName = '', operation = 'operation', result?: T) {

    return (error: HttpErrorResponse): Observable<T> => {
      console.error(`${operation} failed:`, error);
  
      // Detect CORS or network errors (status === 0)
      const isCorsOrNetworkError = error.status === 0;
  
      // Construct a detailed error message
      const message = isCorsOrNetworkError
        ? 'CORS error or Network issue detected. Please check your connection or CORS settings.'
        : `Server returned code ${error.status}, body was: ${JSON.stringify(error.error)}`;
  
      const errorObj = {
        message: message,
        status: isCorsOrNetworkError ? 'CORS/Network Error' : error.status,
        statusText: error.statusText || (isCorsOrNetworkError ? 'CORS/Network Issue' : 'Unknown Error'),
        error: error.error || error.message || 'No error body'
      };
  
      // Return the error object
      return throwError(errorObj);
    };
  }

}

/*

Copyright 2017-2018 Google Inc. All Rights Reserved.

Use of this source code is governed by an MIT-style license that

can be found in the LICENSE file at http://angular.io/license

*/
